import { gql } from '@apollo/client'

const REPORT_MAKER = gql`
  mutation reportMaker($idWatcherAlertReason: UUID, $idRequest: UUID!) {
    updateRequest(
      input: {
        patch: { idWatcherAlertReason: $idWatcherAlertReason }
        id: $idRequest
      }
    ) {
      request {
        id
      }
    }
  }
`
export default REPORT_MAKER
